/**
 * @desc 成交类型下拉组件
 * @description 下拉选项
 * @argument 全部
 * @argument 正常成交
 * @argument 流拍撮合
 * @argument 撮合成交 [前提：系统设置里开启了中标确认]
 */
import React from 'react';
import { Select } from 'antd';
import Api from '@/services';
import { getState } from '@@/store';
import { judgeArr, judgeObj } from '@/shared/functions';
const { Option } = Select;
class DealType extends React.Component {
    constructor(props) {
        super(props);
        /** 默认下拉选项 */
        this.defaultOptions = [
            { key: '', value: '全部' },
            { key: 0, value: '正常成交' },
            { key: 1, value: '流拍撮合' },
        ];
        /** 开启中标确认后增加的下拉选项 */
        this.winningOptions = [
            { key: 2, value: '撮合成交' },
        ];
        this.options = this.defaultOptions;
        // 获取tenantCode
        // 增加容错处理 => 虽然tenantCode是在渲染之前执行的函数，因是异步请求，仍存在拿值的时候没有请求到的情况
        this.getTenantCode = () => {
            return new Promise((resolve) => {
                const tenantCode = () => (getState().userInfo.user.tenantCode);
                if (!tenantCode()) {
                    setTimeout(() => {
                        resolve(tenantCode());
                    }, 200);
                }
                else {
                    resolve(tenantCode());
                }
            });
        };
        // 请求接口获取租户是否在系统中设置中标确认 & 赋值options
        this.requestApi = (tenantCode) => {
            const _param = [{
                    typeId: 110,
                    keyName: tenantCode,
                    enableCache: true,
                }];
            Api.base.getKeyValueListByQueries({ keyValueQueries: JSON.stringify(_param) }).then((res) => {
                if (judgeArr(res) && judgeObj(res[0])) {
                    switch (res[0].value) {
                        case '1':
                            this.options = this.defaultOptions.concat(this.winningOptions);
                            break;
                        case '0':
                        default:
                            this.options = this.defaultOptions;
                    }
                    this.forceUpdate();
                }
            });
        };
        this.handleChange = (value) => {
            this.setState({
                value,
            });
            this.triggerChange(value);
        };
        this.triggerChange = (value) => {
            const { onChange } = this.props;
            if (onChange) {
                onChange(value);
            }
        };
        this.state = {
            value: undefined,
        };
    }
    static getDerivedStateFromProps(props) {
        return props.hasOwnProperty('value') ? {
            value: props.value,
        } : null;
    }
    componentDidMount() {
        this.getTenantCode().then((tenantCode) => {
            this.requestApi(tenantCode);
        });
    }
    render() {
        const { value } = this.state;
        const { placeholder } = this.props;
        return (<Select style={this.props.style} allowClear={this.props.allowClear} onChange={this.handleChange} value={value} placeholder={placeholder || '请选择成交类型'} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
        {this.options.map(item => (<Option key={item.key} value={item.key}>{item.value}</Option>))}
      </Select>);
    }
}
export default DealType;
